import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

interface ICheckDoubleIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const CheckDoubleIcon = ({
  width = styleConfigs.dimensions.width30,
  height = styleConfigs.dimensions.height30,
  color = COLORS.white,
  ...props
}: ICheckDoubleIconProps): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color}>
      <path d="M20.774 8.02997C20.5127 7.82305 20.1795 7.7291 19.8485 7.769C19.5175 7.80891 19.2162 7.97936 19.0115 8.24247L10.2615 19.4925L5.97404 14.2675C5.70021 13.903 5.24966 13.7165 4.79833 13.7808C4.34699 13.8451 3.96645 14.15 3.80532 14.5764C3.64418 15.0029 3.72799 15.4833 4.02404 15.83L9.23654 22.305C9.47482 22.5987 9.8333 22.7688 10.2115 22.7675C10.6137 22.7854 10.9999 22.6086 11.249 22.2925L21.0365 9.79247C21.2381 9.52489 21.3238 9.18759 21.2745 8.85624C21.2251 8.52488 21.0448 8.22721 20.774 8.02997Z" />
      <path d="M27.0258 8.02997C26.7644 7.82305 26.4312 7.7291 26.1003 7.769C25.7693 7.80891 25.468 7.97936 25.2633 8.24247L16.5133 19.4925L15.7508 18.555L14.1758 20.58L15.5508 22.2925C15.7891 22.5862 16.1475 22.7563 16.5258 22.755C16.9061 22.7532 17.265 22.5784 17.5008 22.28L27.2883 9.77997C27.4859 9.51322 27.5692 9.17882 27.52 8.85053C27.4707 8.52224 27.2929 8.22702 27.0258 8.02997Z" />
      <path d="M10.8883 16.5927L12.5008 14.5677L12.2508 14.2677C12.0513 13.9914 11.7478 13.8085 11.4103 13.7613C11.0729 13.7141 10.7308 13.8067 10.4633 14.0177C10.2039 14.226 10.0383 14.5292 10.0031 14.86C9.96792 15.1908 10.066 15.5219 10.2758 15.7802L10.8883 16.5927Z" />
    </g>
  </svg>
);

export default CheckDoubleIcon;
